<template>
  <navbar />
  <section class="work_details">
    <div class="container">
      <h5 class="title"><a :href="project.link" target="_blank">{{ project.title }} <i class="fa-solid fa-link"></i></a></h5>
      <p class="text" v-html="project.description"></p>
      <div class="flex justify-content-center">
        <Galleria v-if="project.images" v-model:activeIndex="activeIndex" v-model:visible="displayCustom" :value="project.images"
          :responsiveOptions="responsiveOptions" :numVisible="7" containerStyle="max-width: 850px" :circular="true"
          :fullScreen="true" :showItemNavigators="true" :showThumbnails="false">
          <template #item="slotProps">
            <!-- <inner-image-zoom :src="slotProps.item" :zoomSrc="slotProps.item" zoomScale="0.5" /> -->
            <Image :src="slotProps.item" preview style="width: 100%; display: block" />
          </template>
        </Galleria>

        <div v-if="project.images" class="grid">
          <div v-for="(image, index) of project.images" :key="index" class="image">
            <img :src="image" :alt="image.alt" style="cursor: pointer" @click="imageClick(index)" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Galleria from 'primevue/galleria';
import { ProjectDetails } from '@/service/ProjectDetails.js';
import navbar from '@/components/layout/navbar.vue';
import Image from 'primevue/image';
// import InnerImageZoom from 'vue-inner-image-zoom';

export default {
  name: "work-details",
  data() {
    return {
      project: {},
      images: null,
      activeIndex: 0,
      responsiveOptions: [
        {
          breakpoint: '1024px',
          numVisible: 5
        },
        {
          breakpoint: '768px',
          numVisible: 3
        },
        {
          breakpoint: '560px',
          numVisible: 1
        }
      ],
      displayCustom: false
    };
  },
  components: {
    navbar,
    Galleria,
    Image,
    // 'inner-image-zoom': InnerImageZoom
  },
  async mounted() {
    const projectId = this.$route.params.id;
    const data = await ProjectDetails.fetchprojectDetails(projectId);
    if (data) {
      this.project = data.data; // Assign the entire response data to images
    }
  },
  methods: {
    imageClick(index) {
      this.activeIndex = index;
      this.displayCustom = true;
    },
  },
}
</script>
